<template>
  <article class="page-login">
    <h1 class="hide-when-embedded">Login</h1>
    <ErrorBox
      v-if="loginError"
      :include-c-s-info="false"
    >
      <template #message>
        <p>
          {{ loginError }}
        </p>
      </template>
    </ErrorBox>
    <p
      v-if="route.query.redirect"
      class="login-to-continue-message"
    >
      Please login to continue
    </p>
    <form
      class="login-form"
      @submit.prevent="login"
    >
      <o-field label="Email">
        <o-input v-model="email" />
      </o-field>
      <o-field label="Password">
        <o-input
          v-model="password"
          type="password"
          password-reveal
        />
      </o-field>
      <o-button native-type="submit">
        Login
      </o-button>      
      <p><router-link :to="{ name: 'password-reset' }">Forgot password?</router-link></p>
      <div class="only-wp-embedded">
        <router-link :to="{ name: 'signup' }">Don't have an account? Sign up</router-link>
      </div>
    </form>
  </article>
</template>
<script setup>
import { ref } from "vue";
import ErrorBox from "../components/alerts/ErrorBox.vue";
import { useAccount } from "../stores/account";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const account = useAccount();
const email = ref("");
const password = ref("");
const loginError = ref(null);

redirectAfterLogin();

async function login() {
  loginError.value = null;
  try {
    const response = await account.login(email.value.trim(), password.value);
    if (response.error_description) {
      loginError.value = response.error_description;
    }
    redirectAfterLogin();
  } catch (error) {
    console.log(error);
    loginError.value = "An error occurred. Please try again in a bit.";
  }
}

function redirectAfterLogin() {
  if (account.accessToken) {
    router.push(route.query.redirect ? route.query.redirect : "/");
  }
}
</script>
<style lang="scss">
.page-login {
  .login-form {
    max-width: 20em;
  }

  .login-to-continue-message {
    color: var(--success-text-color);
  }
}
</style>